<template>
  <div class="appt-confirm bg-white">
    <div class="appt-cap1 t-bold">{{ confirmTitle }}</div>
    <div class="w-100 mt-2" v-if="validationErrors()">
      <p class="w-100 text-center text-red text-italic">
        <strong v-if="validationErrors()"
          >Form not completed. Please correct the following fields and try
          again.</strong
        >
      </p>
      <p class="w-100 text-center text-red">
        <span v-for="(error, index) in validationErrors()" :key="index">{{
          error[0]
        }}</span>
      </p>
    </div>
    <div class="appt-confirm-stages">
      <component
        v-for="(component, a) in confirmComponents"
        :key="a"
        @gotoEdit="gotoEdit(a)"
        :is="component"
      ></component>
    </div>
    <div class="goto-next">
      <div class="btn-back c-pointer" @click="back">Back</div>
      <div
        class="btn-next btn-book c-pointer"
        ref="bknow"
        :class="{ active: canSubmitLead($store) }"
        @click="canSubmitLead($store) && onConfirm($store, $gtm)"
      >
        Book Now
      </div>
    </div>
  </div>
</template>
<script>
import ContactConfirm from "./ContactConfirm.vue";
import ServiceConfirm from "./ServiceConfirm.vue";
import StoreConfirm from "./StoreConfirm.vue";

export default {
  data: () => {
    return {};
  },

  props: {
    useServices: Boolean,
    confirmTitle: String,
    confirmComponents: Array,
    onConfirm: Function,
    canSubmitLead: Function,
  },
  computed: {
    formComplete() {
      return this.$store.getters.formServices;
    },
  },
  methods: {
    scrollToBkNow() {},
    validationErrors() {
      if (this.$store.getters.affiliateErrors) {
        return Object.values(this.$store.getters.affiliateErrors);
      } else return false;
    },
    back() {
      this.$store.commit("setAffiliateErrors", null);
      this.$emit("back");
    },
    gotoEdit(int) {
      this.$store.commit("setAffiliateErrors", null);
      this.$emit("gotoEdit", int);
    },
  },
  components: { StoreConfirm, ServiceConfirm, ContactConfirm },
};
</script>

<style>
.text-red {
  color: #e61d25;
}
</style>
